export default __webpack_public_path__ + "static/media/fj.7e4e2c49.svg";